var map = {
	"./default-failed.svg": 53914,
	"./default-in-progress.svg": 19928,
	"./default-success.svg": 39629,
	"./default.svg": 47868,
	"./ms-business-central-failed.svg": 69770,
	"./ms-business-central-in-progress.svg": 52680,
	"./ms-business-central-success.svg": 51978,
	"./ms-business-central.svg": 31980,
	"./ms-dynamics-custom-failed.svg": 96302,
	"./ms-dynamics-custom-in-progress.svg": 86700,
	"./ms-dynamics-custom-success.svg": 5430,
	"./ms-dynamics-custom.svg": 21328,
	"./ms-dynamics-failed.svg": 23642,
	"./ms-dynamics-in-progress.svg": 86552,
	"./ms-dynamics-success.svg": 42490,
	"./ms-dynamics.svg": 13628,
	"./zoho-failed.svg": 41923,
	"./zoho-in-progress.svg": 84519,
	"./zoho-success.svg": 50285,
	"./zoho.svg": 58315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92559;